import Workspaces from "./views/Workspaces.vue";
import WorkspaceEditor from "./views/WorkspaceEditor.vue";

const moduleRoutes = [
	{
		path: "/:domainId/template/workspaces",
		name: "Workspaces",
		component: Workspaces,
	},

	{
		path: "/:domainId/template/workspaces/:workspaceId",
		name: "Workspace Editor",
		component: WorkspaceEditor,
	},
];

export default moduleRoutes;
